import Userback, { UserbackOptions, UserbackWidget } from "@userback/widget";

const USERBACK_ACCESS_TOKEN = "A-dcPt0AWvxCZjD5hMwgGF9xYyx";

let userbackInstance: UserbackWidget | null = null;

export async function initUserback(options?: UserbackOptions): Promise<UserbackWidget> {
  if (!userbackInstance) {
    userbackInstance = await Userback(USERBACK_ACCESS_TOKEN, options);
  }
  return userbackInstance;
}

export function getUserback(): UserbackWidget | null {
  return userbackInstance;
}

export function identifyUser(userId: string, userInfo: { name?: string; email?: string }): void {
  const userback = getUserback();
  if (userback) {
    userback.identify(userId, userInfo);
  }
}

export function clearUserIdentification(): void {
  const userback = getUserback();
  if (userback) {
    userback.identify("anonymous", {});
  }
}

